import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72b05273"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }

import { ref, onMounted, getCurrentInstance } from 'vue';
import Tools from '@/tools/tools'
import { showToast, showDialog } from 'vant';

export default {
  __name: 'App',
  setup(__props) {

onMounted(() => {
    // 判断当前是否是微信浏览器且是手机设备
    // const isWeixin = Tools.isWeixin();
    // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // if (isWeixin && isMobile) {
    //     // 微信且是手机设备
    //     console.log("This is WeChat on a mobile device");
    //     oAuth()
    // } else {
    //     // 如果不是微信浏览器或不是手机设备，显示提示
    //     showDialog({
    //         title: '提示',
    //         message: '请在手机微信中打开',
    //     }).then(() => {
    //         document.body.innerHTML = '<h2 style="text-align:center; margin-top: 50px;">请在手机微信中打开此页面</h2>';
    //     });
    // }
});


//微信授权
// const oAuth = async () => {
//     const { code } = Tools.parseQuery(window.location.href)

//     if (!code) {
//         //公众号appid
//         const appid = 'wxc10bc7d8d6cea7d8';
//         location.href = getAuthUrl(appid)
//         return
//     } else {
//         auth(code)
//     }
// }

//web端获取微信授权地址
// const getAuthUrl = (appid) => {
// console.log('获取微信授权地址');

// const url = window.location.href
// localStorage.setItem('index_url', url)
// let redirect_uri = encodeURIComponent(url)

// return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
// }


// 对code进行操作
// const auth = async (code) => {
//     console.log('获取微信授权:', code)
//     localStorage.setItem('wx_auth', code)

// const appId = 'wxc10bc7d8d6cea7d8';
// const appSecret = 'f618a7d8a2624c8b5e0938457a819426';
// console.log(`https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appId}&secret=${appSecret}&code=${code}&grant_type=authorization_code`);


// showDialog({
//     title: '提示',
//     message: code,
// })
// }



return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

}